import axios from 'axios';

export async function getList(query: object) {
	return new Promise(resolve => {
		// Build WP REST URL
		const restUrl = process.env.VUE_APP_WORDPRESS_API + 'vue-events-plugin/v1/list/'

		// Returnable object
		let returnable: { status: number, statusText: string, data: object, totalResults: number, totalPages: number } = { status: 0, statusText: '', data: {}, totalResults: 0, totalPages: 0 };

		// Make request to get the menu data
		const ax = axios.get(restUrl, { params: query })
			.then((response) => {
				returnable = {
					status: response.status,
					statusText: response.statusText,
					data: response.data,
					totalResults: parseInt(response.headers['X-Wp-Total'] || response.headers['x-wp-total'] || 0),
					totalPages: parseInt(response.headers['X-Wp-Totalpages'] || response.headers['x-wp-totalpages'] || 0),
				}
				return resolve(returnable);
			})
			.catch((error) => {
				if (error.response) {
					// The request was made and the server responded with a status code
					// that falls out of the range of 2xx
					returnable = {
						status: error.response.status,
						statusText: error.response.data.message || error.response.data || 'Server error',
						data: {},
						totalResults: error.response.headers['X-Wp-Total'] || 0,
						totalPages: error.response.headers['X-Wp-Totalpages'] || 0,
					}
					return resolve(returnable);
				} else if (error.request) {
					// The request was made but no response was received
					// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
					// http.ClientRequest in node.js
					returnable = {
						status: 444,
						statusText: 'No response from server',
						data: {},
						totalResults: 0,
						totalPages: 0,
					}
					return resolve(returnable);
				}

				// Something happened in setting up the request that triggered an Error
				returnable = {
					status: 999,
					statusText: error.message || 'Unknown error',
					data: {},
					totalResults: 0,
					totalPages: 0,
				}
				return resolve(returnable);
			})

		return ax;
	});
}

export async function get(eventId: number) {
	return new Promise(resolve => {
		// Build WP REST URL
		const restUrl = process.env.VUE_APP_WORDPRESS_API + 'vue-events-plugin/v1/get/?permalink=' + eventId

		// Returnable object
		let returnable: { status: number, statusText: string, data: object } = { status: 0, statusText: '', data: {} };

		// Make request to get the menu data
		const ax = axios.get(restUrl)
			.then((response) => {
				returnable = {
					status: response.status,
					statusText: response.statusText,
					data: response.data
				}
				return resolve(returnable);
			})
			.catch((error) => {
				if (error.response) {
					// The request was made and the server responded with a status code
					// that falls out of the range of 2xx
					returnable = {
						status: error.response.status,
						statusText: error.response.data.message || error.response.data || 'Server error',
						data: {}
					}
					return resolve(returnable);
				} else if (error.request) {
					// The request was made but no response was received
					// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
					// http.ClientRequest in node.js
					returnable = {
						status: 444,
						statusText: 'No response from server',
						data: {}
					}
					return resolve(returnable);
				}

				// Something happened in setting up the request that triggered an Error
				returnable = {
					status: 999,
					statusText: error.message || 'Unknown error',
					data: {}
				}
				return resolve(returnable);
			})

		return ax;
	});
}
